"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
const ActorAdded_1 = require("../events/core/ActorAdded");
const ActionState_1 = require("../actions/ActionState");
const ActorState_1 = require("../actors/ActorState");
const Demand_1 = require("../Demand");
const Duration_1 = require("../Duration");
const EffectState_1 = require("../effects/EffectState");
const AttributeType_1 = require("../enums/AttributeType");
const Faction_1 = require("../enums/Faction");
const TargetType_1 = require("../enums/TargetType");
const EventHandlerState_1 = require("../event-handlers/EventHandlerState");
const EventState_1 = require("../events/EventState");
const EventType_1 = require("../events/EventType");
const Target_1 = require("../Target");
const IdArray_1 = require("../utils/IdArray");
const Record_1 = require("../../utils/Record");
const Registries_1 = require("./Registries");
const AttributeChanged_1 = require("../events/core/AttributeChanged");
const EffectType_1 = require("../effects/EffectType");
const AbilityState_1 = require("../abilities/AbilityState");
const Schedule_1 = require("../Schedule");
const EventFilter_1 = require("../events/EventFilter");
const EffectApplied_1 = require("../events/core/EffectApplied");
const EffectCancelled_1 = require("../events/core/EffectCancelled");
const DurationType_1 = require("../enums/DurationType");
const CancelEffects_1 = require("../event-handlers/core/CancelEffects");
const AbilityUsed_1 = require("../events/core/AbilityUsed");
const CancelEventHandlers_1 = require("../event-handlers/core/CancelEventHandlers");
const TurnMeterChanged_1 = require("../events/core/TurnMeterChanged");
const EventHandlerRegistered_1 = require("../events/core/EventHandlerRegistered");
const EventHandlerCancelled_1 = require("../events/core/EventHandlerCancelled");
const AiState_1 = require("../ai/AiState");
const AbilityType_1 = require("../abilities/AbilityType");
const DisableAbility_1 = require("../effects/core/DisableAbility");
const AbilityDisabled_1 = require("../events/core/AbilityDisabled");
const AbilityEnabled_1 = require("../events/core/AbilityEnabled");
const EnableAbility_1 = require("../effects/core/EnableAbility");
const __1 = require("../..");
const RoomState_1 = require("../rooms/RoomState");
const ActorType_1 = require("../actors/ActorType");
const AdventureState_1 = require("../adventures/AdventureState");
const ApplyAttackDamage_1 = require("../state-extensions/ApplyAttackDamage");
const ApplyAttackDamages_1 = require("../state-extensions/ApplyAttackDamages");
const ApplyAttack_1 = require("../state-extensions/ApplyAttack");
const ApplyAttackWithDamage_1 = require("../state-extensions/ApplyAttackWithDamage");
const ApplyExactDamage_1 = require("../state-extensions/ApplyExactDamage");
const ApplyHealing_1 = require("../state-extensions/ApplyHealing");
const ApplyProjectileAttackWithDamage_1 = require("../state-extensions/ApplyProjectileAttackWithDamage");
const ApplyProjectileAttacksWithDamage_1 = require("../state-extensions/ApplyProjectileAttacksWithDamage");
const ApplyJumpingProjectileAttackWithDamage_1 = require("../state-extensions/ApplyJumpingProjectileAttackWithDamage");
const ApplyAttribute_1 = require("../utils/ApplyAttribute");
const ApplyDebuff_1 = require("../state-extensions/ApplyDebuff");
const Effects_1 = require("../../metadata/Effects");
const enums_1 = require("../enums");
const ApplyBuff_1 = require("../state-extensions/ApplyBuff");
const ApplyBuffs_1 = require("../state-extensions/ApplyBuffs");
const ApplyDebuffs_1 = require("../state-extensions/ApplyDebuffs");
const SequenceBuilder_1 = require("../vfx/SequenceBuilder");
const Locals_1 = require("../state-extensions/Locals");
const Permanents_1 = require("../state-extensions/Permanents");
const ApplyProjectiles_1 = require("../state-extensions/ApplyProjectiles");
const ApplyMultiAttack_1 = require("../state-extensions/ApplyMultiAttack");
const ApplyAbilityAnimation_1 = require("../state-extensions/ApplyAbilityAnimation");
const core_1 = require("../events/core");
const Logger_1 = require("../../Logger");
const Math_1 = require("../../utils/Math");
const ApplyDotDamageV2_1 = require("../state-extensions/ApplyDotDamageV2");
const RemoveDebuffs_1 = require("../state-extensions/RemoveDebuffs");
const RemoveRandomBuff_1 = require("../state-extensions/RemoveRandomBuff");
class State {
    constructor() {
        this.version = 0;
        this.vfxSequenceEffectIds = [];
        this.turnMeter = {};
        this.nextActor = 0;
        this.eventSequence = 1;
        this.actionSequence = 1;
        this.nextId = 1000;
        this.lastTurnStartedAt = 0;
        this.actors = {
            0: {
                id: 0,
                playerId: "",
                characterId: "",
                characterXp: 0,
                characterXpToLevel: 0,
                rarity: enums_1.Rarity.Common,
                actionsTaken: 0,
                archetypeNames: [],
                lastAttackedBy: 0,
                locals: {},
                permanents: {},
                ownerId: 0,
                level: Number.MAX_SAFE_INTEGER,
                classType: ActorType_1.ActorType.None,
                faction: Faction_1.Faction.Game,
                turnCount: 0,
                abilities: {},
                baseAttributeValues: {},
                attributeValues: {},
                maxAttributeValues: {},
                eventHandlers: {},
                equipment: {},
                companionIds: [],
                effects: {}
            }
        };
        this.allies = [];
        this.enemies = [];
        this.ai = {};
        this.featureEnabled = {};
        this.events = [];
        this.effects = {};
        this.eventHandlers = {};
        this.eventHandlersByEventType = {};
        this.rooms = {};
        this.currentRoom = 0;
        this.applyMultiAttack = ApplyMultiAttack_1.applyMultiAttack;
        this.setLocal = Locals_1.setLocal;
        this.unsetLocal = Locals_1.unsetLocal;
        this.readLocal = Locals_1.readLocal;
        this.setPermanent = Permanents_1.setPermanent;
        this.unsetPermanent = Permanents_1.unsetPermanent;
        this.readPermanent = Permanents_1.readPermanent;
        this.applyAbilityAnimation = ApplyAbilityAnimation_1.applyAbilityAnimation;
        this.applyBuff = ApplyBuff_1.applyBuff;
        this.applyBuffs = ApplyBuffs_1.applyBuffs;
        this.applyDebuff = ApplyDebuff_1.applyDebuff;
        this.applyDebuffs = ApplyDebuffs_1.applyDebuffs;
        this.applyProjectiles = ApplyProjectiles_1.applyProjectiles;
        this.applyAttackDamage = ApplyAttackDamage_1.applyAttackDamage;
        this.applyAttackDamages = ApplyAttackDamages_1.applyAttackDamages;
        this.applyAttack = ApplyAttack_1.applyAttack;
        this.applyAttackWithDamage = ApplyAttackWithDamage_1.applyAttackWithDamage;
        this.applyDoTDamageV2 = ApplyDotDamageV2_1.applyDoTDamageV2;
        this.applyExactDamage = ApplyExactDamage_1.applyExactDamage;
        this.applyProjectileAttackWithDamage = ApplyProjectileAttackWithDamage_1.applyProjectileAttackWithDamage;
        this.applyProjectileAttacksWithDamage = ApplyProjectileAttacksWithDamage_1.applyProjectileAttacksWithDamage;
        this.applyJumpingProjectileAttackWithDamage = ApplyJumpingProjectileAttackWithDamage_1.applyJumpingProjectileAttackWithDamage;
        this.removeDebuffs = RemoveDebuffs_1.removeDebuffs;
        this.removeRandombuff = RemoveRandomBuff_1.removeRandomBuff;
        this.applyHealing = ApplyHealing_1.applyHealing;
    }
    ////////////////
    // Extensions //
    ////////////////
    static hydrate(state) {
        Object.setPrototypeOf(state, State.prototype);
        state.setLocal = Locals_1.setLocal;
        state.unsetLocal = Locals_1.unsetLocal;
        state.readLocal = Locals_1.readLocal;
        state.setPermanent = Permanents_1.setPermanent;
        state.unsetPermanent = Permanents_1.unsetPermanent;
        state.readPermanent = Permanents_1.readPermanent;
        state.applyAbilityAnimation = ApplyAbilityAnimation_1.applyAbilityAnimation;
        state.applyBuff = ApplyBuff_1.applyBuff;
        state.applyBuffs = ApplyBuffs_1.applyBuffs;
        state.applyDebuff = ApplyDebuff_1.applyDebuff;
        state.applyDebuffs = ApplyDebuffs_1.applyDebuffs;
        state.applyMultiAttack = ApplyMultiAttack_1.applyMultiAttack;
        state.applyProjectiles = ApplyProjectiles_1.applyProjectiles;
        state.applyAttackDamage = ApplyAttackDamage_1.applyAttackDamage;
        state.applyAttackDamages = ApplyAttackDamages_1.applyAttackDamages;
        state.applyAttack = ApplyAttack_1.applyAttack;
        state.applyAttackWithDamage = ApplyAttackWithDamage_1.applyAttackWithDamage;
        state.applyDoTDamageV2 = ApplyDotDamageV2_1.applyDoTDamageV2;
        state.applyExactDamage = ApplyExactDamage_1.applyExactDamage;
        state.applyHealing = ApplyHealing_1.applyHealing;
        state.applyProjectileAttackWithDamage = ApplyProjectileAttackWithDamage_1.applyProjectileAttackWithDamage;
        state.applyProjectileAttacksWithDamage = ApplyProjectileAttacksWithDamage_1.applyProjectileAttacksWithDamage;
        state.removeDebuffs = RemoveDebuffs_1.removeDebuffs;
        state.removeRandombuff = RemoveRandomBuff_1.removeRandomBuff;
        state.applyJumpingProjectileAttackWithDamage = ApplyJumpingProjectileAttackWithDamage_1.applyJumpingProjectileAttackWithDamage;
        return state;
    }
    /////////////
    // Version //
    /////////////
    nextVersion() {
        this.version++;
    }
    //////////////
    // Features //
    //////////////
    setFeatureEnabled(key, value) {
        this.featureEnabled = this.featureEnabled || {};
        this.featureEnabled[key] = value;
    }
    ////////////
    //  Game  //
    ////////////
    startGame(sequence) {
        (0, Demand_1.demand)(this.adventure !== undefined, "ADVENTURE_NOT_SET");
        (0, Demand_1.demand)(this.adventure.state === "Pending", "ADVENTURE_ALREADY_STARTED");
        Registries_1.AdventureHandlers.getItem(this.adventure.__typeName).init(sequence, this, this.adventure);
        (0, Demand_1.demand)(this.currentRoom > 0, "ROOM_NOT_SET");
        const initSequence = sequence.pushSequence("parallel");
        this.adventure.state = "Active";
        for (const actor of this.getActors()) {
            this.initAbilities(initSequence, actor.id);
        }
        this.emitEvent(sequence, this.adventure.id, new __1.AdventureStartedEventArgs());
    }
    ////////
    // AI //
    ////////
    setAi(sequence, actorId, type, args) {
        const state = new AiState_1.AiState(actorId, type, args);
        (0, Record_1.setValue)(this.ai, actorId, state);
        Registries_1.Ai.getItem(type).init(sequence, this, state);
    }
    unsetAi(actorId) {
        (0, Record_1.unsetValue)(this.ai, actorId);
    }
    getAi(actorId) {
        return (0, Record_1.getValueOrThrow)(this.ai, actorId, "NO_AI");
    }
    hasAi(actorId) {
        return (0, Record_1.hasValue)(this.ai, actorId);
    }
    runAi(sequence, actorId) {
        if (this.nextActor !== actorId) {
            return;
        }
        (0, Demand_1.demand)(this.hasAi(actorId), "NO_AI");
        const state = this.getAi(actorId);
        const livingEnemies = this.selectLivingTargets(actorId, Target_1.Target.AllEnemies);
        if (livingEnemies.length === 0) {
            return;
        }
        Registries_1.Ai.getItem(state.__typeName).nextTurn(sequence, this, state);
    }
    ////////////
    // Actors //
    ////////////
    getActor(actorId) {
        return this.actors[actorId];
    }
    getActors() {
        const all = [];
        for (const ally of this.allies) {
            all.push(this.getActor(ally));
        }
        for (const enemy of this.enemies) {
            all.push(this.getActor(enemy));
        }
        return all;
    }
    addActor(sequence, args, enabled = false) {
        let attributes = {};
        if (args.__type !== "playerv2") {
            for (const [key] of Object.entries(args.initialAttributes)) {
                const value = args.initialAttributes[+key];
                (0, ApplyAttribute_1.applyAttribute)(args.level, attributes, +key, value);
            }
            for (const state of Object.values(args.initialEquipment)) {
                for (const attribute of state.item.attributes) {
                    let toAdd = attribute.amount;
                    if ((0, AttributeType_1.isPrimaryAttribute)(attribute.attribute)) {
                        const percent = attribute.amount * .01;
                        toAdd = Math.round((0, Record_1.getValueOrDefault)(args.initialAttributes, attribute.attribute, 1) * percent);
                    }
                    (0, ApplyAttribute_1.applyAttribute)(args.level, attributes, attribute.attribute, toAdd);
                }
            }
        }
        else {
            attributes = args.initialAttributes;
        }
        // When adding non-allies without an ai key, we need to assign the rando ai.
        if (args.faction !== Faction_1.Faction.Ally && args.__type === "npc" && args.aiKey === "None") {
            args.aiKey = "Rando";
            args.aiArgs = {};
        }
        let characterXpToLevel = args.__type === "playerv2" ? args.characterXpToLevel
            : Number.MAX_SAFE_INTEGER;
        let characterXp = args.__type === "playerv2" ? args.characterXp
            : 0;
        const actor = new ActorState_1.ActorState(this.nextId++, args.classType, args.faction, args.level, attributes, args.initialAbilities, args.initialEquipment, args.archetypes || [], args.rarity, args.playerId, args.characterId, characterXp, characterXpToLevel);
        (0, Record_1.setValue)(this.actors, actor.id, actor);
        (0, Record_1.setValue)(this.turnMeter, actor.id, 0);
        if (args.__type === "npc" && args.aiKey !== "None") {
            this.setAi(sequence, actor.id, args.aiKey, args.aiArgs);
        }
        this.emitEvent(sequence, actor.id, new ActorAdded_1.ActorAddedEventArgs(args));
        // effects should be added after the actor is enabled.
        args.effects.forEach(({ applyTo, duration, supernatural, effect }) => {
            this.registerEventHandlerScript(actor.id, EventType_1.EventType.ActorEnabled, Schedule_1.Schedule.Once(), "ApplyEffects_OnEvent", {
                target: applyTo !== null && applyTo !== void 0 ? applyTo : Target_1.Target.Self,
                effects: [
                    {
                        duration: duration !== null && duration !== void 0 ? duration : Duration_1.Duration.Permanent,
                        supernatural: supernatural !== null && supernatural !== void 0 ? supernatural : true,
                        effect
                    }
                ]
            });
        });
        sequence.push(__1.UpdateHealthBarVfxVfxStepArgs.fromActor(this, actor.id));
        this.setTurnMeter(sequence, actor.id, 0);
        // Init the abilities of actors that are added later in the game.
        if (this.adventure.state !== "Pending") {
            this.initAbilities(sequence, actor.id);
        }
        if (enabled) {
            this.enableActor(sequence, actor.id);
        }
        return actor.id;
    }
    initAbilities(sequence, actorId) {
        const actor = this.getActor(actorId);
        const abilitySlots = this.getEquippedAbilitySlots(actor.id);
        for (const abilitySlot of abilitySlots) {
            const ability = this.getAbilityInSlot(actor.id, abilitySlot);
            Registries_1.Abilities.getItem(AbilityType_1.AbilityType[ability.abilityType]).init(sequence, this, actor.id);
        }
    }
    enableActor(sequence, actorId) {
        this.setTurnMeter(sequence, actorId, 0);
        const actor = this.getActor(actorId);
        switch (actor.faction) {
            case Faction_1.Faction.Ally:
                this.allies.push(actorId);
                break;
            case Faction_1.Faction.Enemy:
                this.enemies.push(actorId);
                break;
        }
        this.emitEvent(sequence, actorId, new __1.ActorEnabledEventArgs());
    }
    disableActor(sequence, actorId) {
        this.setTurnMeter(sequence, actorId, 0);
        const actor = this.getActor(actorId);
        switch (actor.faction) {
            case Faction_1.Faction.Ally:
                (0, IdArray_1.removeElement)(this.allies, actorId);
                break;
            case Faction_1.Faction.Enemy:
                (0, IdArray_1.removeElement)(this.enemies, actorId);
                break;
        }
        this.emitEvent(sequence, actorId, new __1.ActorDisabledEventArgs());
    }
    getSummonedCompanions(actorId) {
        const ids = [];
        const actor = this.getActor(actorId);
        for (const companion of (actor === null || actor === void 0 ? void 0 : actor.companionIds) || []) {
            if (!this.hasEffectOfType(companion, EffectType_1.EffectType.Summoned)) {
                continue;
            }
            ids.push(companion);
        }
        return ids;
    }
    addCompanion(sequence, actorId, args) {
        const companionId = this.addActor(sequence, args);
        const companion = this.getActor(companionId);
        companion.ownerId = actorId;
        const actor = this.getActor(actorId);
        actor.companionIds.push(companionId);
        this.emitEvent(sequence, actor.id, new __1.CompanionAddedEventArgs(companionId));
        this.enableActor(sequence, companionId);
        return companionId;
    }
    summonCompanion(sequence, summonerId, args, duration = Duration_1.Duration.Permanent) {
        const companionId = this.addCompanion(sequence, summonerId, args);
        this.applyBuff({
            sequence,
            creatorId: summonerId,
            targetId: companionId,
            duration: duration,
            effect: new __1.SummonedEffectArgs(),
            supernatural: true,
        });
        return companionId;
    }
    unsummonCompanion(sequence, targetId) {
        const [effect] = this.getEffectsOfType(targetId, EffectType_1.EffectType.Summoned);
        this.cancelEffect(sequence, effect);
    }
    unsummonAllSummonedCompanions(sequence, summonerId) {
        sequence = sequence.pushSequence("parallel");
        for (const companion of this.getSummonedCompanions(summonerId)) {
            this.unsummonCompanion(sequence, companion);
        }
    }
    getAbilityInSlot(actorId, slot) {
        const actor = this.getActor(actorId);
        return actor.abilities[slot];
    }
    getEquippedAbilitySlots(actorId) {
        const actor = this.getActor(actorId);
        if (!actor) {
            return [];
        }
        const slots = [];
        for (const [key, value] of Object.entries(actor.abilities)) {
            if (value) {
                slots.push(+key);
            }
        }
        return slots;
    }
    getEquippedAbility(actorId, key) {
        const actor = this.getActor(actorId);
        const slots = this.getEquippedAbilitySlots(actorId);
        for (let i = 0; i < slots.length; i++) {
            const ability = actor.abilities[slots[i]];
            if (ability.abilityType === key) {
                return [slots[i], ability];
            }
        }
        return [];
    }
    getLevel(actorId) {
        return this.actors[actorId].level;
    }
    setHealth(sequence, actorId, value) {
        value = Math.max(0, value);
        (0, Record_1.setValue)(this.getActor(actorId).attributeValues, AttributeType_1.AttributeType.Health, value);
        sequence.push(__1.UpdateHealthBarVfxVfxStepArgs.fromActor(this, actorId));
        this.emitEvent(sequence, actorId, new AttributeChanged_1.AttributeChangedEventArgs(AttributeType_1.AttributeType.Health, value));
    }
    getHealth(actorId) {
        return this.getAttributeScore(actorId, "Health");
    }
    getPercentOfHealth(actorId, percent) {
        return this.getPercentOfAttributeScore(actorId, percent, "Health");
    }
    getMaxHealth(actorId) {
        return this.getMaxAttributeScore(actorId, "Health");
    }
    getPercentOfMaxHealth(actorId, percent) {
        return this.getPercentOfMaxAttributeScore(actorId, percent, "Health");
    }
    getBaseHealth(actorId) {
        return this.getBaseAttributeScore(actorId, "Health");
    }
    getPercentOfBaseHealth(actorId, percent) {
        return this.getPercentOfBaseAttributeScore(actorId, percent, "Health");
    }
    getCurrentHealthPercent(actorId) {
        return Math.round(this.getHealth(actorId) / this.getMaxHealth(actorId));
    }
    calculateBuffAmount(casterId, targetId, percent, scalingAttribute, increaseAttribute) {
        const caster = Math.max(1, this.getAttributeScore(casterId, scalingAttribute));
        const target = Math.max(1, this.getAttributeScore(targetId, increaseAttribute));
        const cap = Math.ceil(this.getPercentOfBaseAttributeScore(casterId, percent, scalingAttribute) * percent * .01);
        const fromCaster = Math.min(cap, (caster / target) * this.getPercentOfBaseAttributeScore(casterId, percent, scalingAttribute));
        const fromTarget = Math.min(cap, (target / caster) * this.getPercentOfBaseAttributeScore(target, percent, increaseAttribute));
        return Math.ceil(fromCaster + fromTarget);
    }
    getPercentOfAttributeScore(actorId, percent, attribute) {
        const score = this.getAttributeScore(actorId, attribute);
        return Math.round(score * percent / 100);
    }
    getAttributeScore(actorId, attribute) {
        var _a;
        attribute = (0, __1.enumValue)(AttributeType_1.AttributeType, attribute !== null && attribute !== void 0 ? attribute : "None");
        const actor = this.getActor(actorId);
        return (0, Record_1.getValueOrDefaultTo)((_a = actor === null || actor === void 0 ? void 0 : actor.attributeValues) !== null && _a !== void 0 ? _a : {}, attribute, 0);
    }
    getAttributeScores(actorId, attributes) {
        return attributes.map(attribute => this.getAttributeScore(actorId, attribute));
    }
    hasAttribute(actorId, attribute) {
        var _a;
        attribute = (0, __1.enumValue)(AttributeType_1.AttributeType, attribute !== null && attribute !== void 0 ? attribute : "None");
        const actor = this.getActor(actorId);
        return (0, Record_1.getValueOrDefaultTo)((_a = actor === null || actor === void 0 ? void 0 : actor.attributeValues) !== null && _a !== void 0 ? _a : {}, attribute, 0) > 0;
    }
    getPercentOfBaseAttributeScore(actorId, percent, attribute) {
        const score = this.getBaseAttributeScore(actorId, attribute);
        // ensure a minimum value of 1 is always returned
        return Math.max(1, Math.round(score * percent / 100));
    }
    getBaseAttributeScore(actorId, attribute) {
        var _a, _b;
        attribute = (0, __1.enumValue)(AttributeType_1.AttributeType, attribute !== null && attribute !== void 0 ? attribute : "None");
        const actor = this.getActor(actorId);
        // older games will not have a base attribute values, so to keep this method backwards compatible, we'll use the max attribute values.
        return (0, Record_1.getValueOrDefaultTo)((_b = (_a = actor === null || actor === void 0 ? void 0 : actor.baseAttributeValues) !== null && _a !== void 0 ? _a : actor === null || actor === void 0 ? void 0 : actor.maxAttributeValues) !== null && _b !== void 0 ? _b : {}, attribute, 0);
    }
    getPercentOfMaxAttributeScore(actorId, percent, attribute) {
        const score = this.getMaxAttributeScore(actorId, attribute);
        // ensure a minimum value of 1 is always returned
        return Math.max(1, Math.round(score * percent / 100));
    }
    getMaxAttributeScore(actorId, attribute) {
        var _a;
        attribute = (0, __1.enumValue)(AttributeType_1.AttributeType, attribute !== null && attribute !== void 0 ? attribute : "None");
        const actor = this.getActor(actorId);
        return (0, Record_1.getValueOrDefaultTo)((_a = actor === null || actor === void 0 ? void 0 : actor.maxAttributeValues) !== null && _a !== void 0 ? _a : {}, attribute, 0);
    }
    setMaxAttributeScore(sequence, actorId, attribute, value) {
        attribute = (0, __1.enumValue)(AttributeType_1.AttributeType, attribute !== null && attribute !== void 0 ? attribute : "None");
        if ((0, AttributeType_1.isPrimaryAttribute)(attribute) || attribute === AttributeType_1.AttributeType.Health) {
            value = Math.max(0, value);
        }
        const actor = this.getActor(actorId);
        if (!actor) {
            return;
        }
        const lastPrimaryValue = (0, Record_1.getValueOrDefaultTo)(actor.maxAttributeValues, attribute, 0);
        const diff = value - lastPrimaryValue;
        // 100 to  80 =  20 (increase)
        //  80 to 100 = -20 (decrease)
        (0, Record_1.setValue)(this.actors[actorId].maxAttributeValues, attribute, value);
        this.emitEvent(sequence, actorId, new __1.MaxAttributeChangedEventArgs(attribute, value));
        // Set the current attribute score
        const lastCurrentValue = (0, Record_1.getValueOrDefaultTo)(actor.attributeValues, attribute, 0);
        switch (true) {
            case attribute === AttributeType_1.AttributeType.Health && this.isDeceased(actorId): {
                // when a character is dead, we don't want to change their current hit points
                break;
            }
            case diff > 0: {
                // when the value is increasing, we increase the current score
                const result = (0, Record_1.setValue)(actor.attributeValues, attribute, lastCurrentValue + diff);
                this.emitEvent(sequence, actorId, new AttributeChanged_1.AttributeChangedEventArgs(attribute, result));
                break;
            }
            case diff < 0 && lastCurrentValue > value: {
                // when the value is decreasing and the current score is greater than the new max, we decrease the score
                const result = (0, Record_1.setValue)(actor.attributeValues, attribute, value);
                this.emitEvent(sequence, actorId, new AttributeChanged_1.AttributeChangedEventArgs(attribute, result));
                break;
            }
            default: { }
        }
        const percentChanges = Array.of();
        const flatChanges = Array.of();
        switch (attribute) {
            case AttributeType_1.AttributeType.Health: {
                sequence.push(__1.UpdateHealthBarVfxVfxStepArgs.fromActor(this, actorId));
                break;
            }
            case AttributeType_1.AttributeType.Vitality: {
                flatChanges.push({
                    attribute: AttributeType_1.AttributeType.Health,
                    value: (0, Record_1.getValueOrDefaultTo)(actor.maxAttributeValues, AttributeType_1.AttributeType.Health, 0) + 5 * diff
                });
                flatChanges.push({
                    attribute: AttributeType_1.AttributeType.PercentHealingIncrease,
                    value: (0, Record_1.getValueOrDefaultTo)(actor.maxAttributeValues, AttributeType_1.AttributeType.PercentHealingIncrease, 0) + .1 * diff
                });
                break;
            }
            case AttributeType_1.AttributeType.Luck: {
                percentChanges.push(AttributeType_1.AttributeType.CriticalStrikeChance);
                break;
            }
        }
        flatChanges.forEach(({ attribute: secondaryAttribute, value }) => {
            this.setMaxAttributeScore(sequence, actorId, secondaryAttribute, value);
        });
        const nextPrimaryValue = (0, Record_1.getValueOrDefaultTo)(actor.maxAttributeValues, attribute, 0);
        percentChanges.forEach(secondaryAttribute => {
            const last = (0, Math_1.calculateLevelScaledLog)(actor.level, lastPrimaryValue);
            const next = (0, Math_1.calculateLevelScaledLog)(actor.level, nextPrimaryValue);
            const secondaryDiff = next - last;
            if (secondaryDiff === 0) {
                return;
            }
            const lastSecondaryValue = (0, Record_1.getValueOrDefaultTo)(actor.maxAttributeValues, secondaryAttribute, 0);
            this.setMaxAttributeScore(sequence, actorId, secondaryAttribute, lastSecondaryValue + secondaryDiff);
        });
    }
    testAttribute(actorId, attribute, percentChance) {
        let rolls = this.calculateAttributeRollCount(actorId, attribute);
        let success = false;
        while (!success && rolls > 0) {
            success = (0, __1.randomPercent)() <= percentChance;
            rolls -= 1;
        }
        return success;
    }
    calculateAttributeRollCount(actorId, attribute) {
        const attrValue = this.getMaxAttributeScore(actorId, attribute);
        return Math.max(1, Math.round(Math.log(attrValue)));
    }
    setFaction(sequence, actorId, faction) {
        const previous = this.actors[actorId].faction;
        if (previous === faction) {
            return;
        }
        this.actors[actorId].faction = faction;
        this.emitEvent(sequence, actorId, new core_1.FactionChangedEventArgs(previous, faction));
    }
    getFaction(actorId) {
        return this.actors[actorId].faction;
    }
    isDeceased(actorId) {
        return !(0, Record_1.hasValue)(this.actors, actorId) || this.hasEffectOfType(actorId, EffectType_1.EffectType.Death);
    }
    isFullHealth(actorId) {
        return (this.getAttributeScore(actorId, AttributeType_1.AttributeType.Health) >= this.getMaxAttributeScore(actorId, AttributeType_1.AttributeType.Health));
    }
    selectTargets(self, target) {
        var _a;
        const selfFaction = this.getFaction(self);
        const friends = selfFaction === Faction_1.Faction.Ally ? this.allies
            : this.enemies;
        const notFriends = selfFaction === Faction_1.Faction.Ally ? this.enemies
            : this.allies;
        switch (target.type) {
            case TargetType_1.TargetType.None:
                return [];
            case TargetType_1.TargetType.Any:
                return target.actorIds;
            case TargetType_1.TargetType.All:
                return this.getActors()
                    .map(({ id }) => id);
            case TargetType_1.TargetType.AllButSelf:
                return this.getActors()
                    .filter(actor => actor.id !== self)
                    .map(({ id }) => id);
            case TargetType_1.TargetType.Self:
                return [self];
            case TargetType_1.TargetType.AllAllies:
                return friends;
            case TargetType_1.TargetType.OneAllies:
                (0, Demand_1.demand)(target.actorIds.length <= 1, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => friends.includes(id)), "ALLY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.TwoAllies:
                (0, Demand_1.demand)(target.actorIds.length <= 2, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => friends.includes(id)), "ALLY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.ThreeAllies:
                (0, Demand_1.demand)(target.actorIds.length <= 3, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => friends.includes(id)), "ALLY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.FourAllies:
                (0, Demand_1.demand)(target.actorIds.length <= 4, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => friends.includes(id)), "ALLY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.OneCompanion: {
                const allCompanions = new Set(this.getActors().flatMap(actor => actor.companionIds));
                (0, Demand_1.demand)(target.actorIds.length <= 1, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => allCompanions.has(id)), "TARGET_NOT_COMPANION");
                return target.actorIds;
            }
            case TargetType_1.TargetType.AllCompanions: {
                const allCompanions = new Set(this.getActors().flatMap(actor => actor.companionIds));
                return Array.from(allCompanions);
            }
            case TargetType_1.TargetType.AllAllyCompanions:
                return friends.flatMap(id => this.getSummonedCompanions(id));
            case TargetType_1.TargetType.AllEnemyCompanions:
                return notFriends.flatMap(id => this.getSummonedCompanions(id));
            case TargetType_1.TargetType.AllEnemies:
                return notFriends;
            case TargetType_1.TargetType.OneEnemies:
                (0, Demand_1.demand)(target.actorIds.length <= 1, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => notFriends.includes(id)), "ENEMY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.TwoEnemies:
                (0, Demand_1.demand)(target.actorIds.length <= 2, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => notFriends.includes(id)), "ENEMY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.ThreeEnemies:
                (0, Demand_1.demand)(target.actorIds.length <= 3, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => notFriends.includes(id)), "ENEMY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.FourEnemies:
                (0, Demand_1.demand)(target.actorIds.length <= 4, "INVALID_TARGET_POSITIONS");
                (0, Demand_1.demand)(target.actorIds.every(id => notFriends.includes(id)), "ENEMY_NOT_FOUND");
                return target.actorIds;
            case TargetType_1.TargetType.InFront:
                return [];
            case TargetType_1.TargetType.Behind:
                return [];
            case TargetType_1.TargetType.LastAttackedBy:
                return [(_a = this.getActor(self)) === null || _a === void 0 ? void 0 : _a.lastAttackedBy]
                    .filter(targetId => targetId > 0);
            default:
                console.error(`Target type ${target.type} (${TargetType_1.TargetType[target.type]}) is unknown`, target);
                throw new Error("INVALID_TARGET");
        }
    }
    selectLivingTargets(actorId, target) {
        const livingTargets = [];
        for (const id of this.selectTargets(actorId, target)) {
            if (this.isDeceased(id)) {
                continue;
            }
            livingTargets.push(id);
        }
        return livingTargets;
    }
    getTurnMeter(actorId) {
        return this.turnMeter[actorId];
    }
    setTurnMeter(sequence, actorId, value) {
        this.turnMeter[actorId] = value;
        this.emitEvent(sequence, actorId, new TurnMeterChanged_1.TurnMeterChangedEventArgs(value));
    }
    /////////////
    // Effects //
    /////////////
    applyEffect(sequence, creatorId, targetId, args, duration = Duration_1.Duration.Permanent, supernatural = false) {
        sequence = sequence.pushSequence("sequential");
        const effect = new EffectState_1.EffectState(this.nextId++, duration, creatorId, targetId, args, supernatural);
        // EngineLogger.debug(`100|applyEffect|adventureId#${this.adventure.adventureId}|creatorId#${creatorId}|targetId#${targetId}|effectId#${effect.id}|effectType#${EffectType[args.__type]}`)
        (0, Record_1.setValue)(this.effects, effect.id, effect);
        const actor = this.actors[targetId];
        if (effect.duration.type !== DurationType_1.DurationType.Instant) {
            const actorEffects = (0, Record_1.getValueOrDefaultTo)(actor.effects, args.__type, []);
            actorEffects.push(effect.id);
        }
        Registries_1.Effects.getItem(args.__type).apply(sequence, this, effect);
        this.emitEvent(sequence, targetId, new EffectApplied_1.EffectAppliedEventArgs(effect.id));
        if (effect.removed) {
            return;
        }
        const handlersToRemove = [];
        switch (duration.type) {
            case DurationType_1.DurationType.EndOfTurn:
                handlersToRemove.push(this.registerEventHandler(this.nextActor, EventType_1.EventType.TurnEnded, Schedule_1.Schedule.Once(), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])), this.registerEventHandler(this.nextActor, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])));
                break;
            case DurationType_1.DurationType.Ticks:
                effect.appliedOnTurn = actor.turnCount;
                handlersToRemove.push(this.registerEventHandler(effect.targetId, EventType_1.EventType.Tick, Schedule_1.Schedule.Combined(duration.value, 1), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])), this.registerEventHandler(effect.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])));
                break;
            case DurationType_1.DurationType.Permanent:
                handlersToRemove.push(this.registerEventHandler(effect.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])));
                break;
            case DurationType_1.DurationType.Turns: {
                effect.appliedOnTurn = actor.turnCount;
                const durationValue = effect.targetId === this.nextActor ? duration.value + 1
                    : duration.value;
                handlersToRemove.push(this.registerEventHandler(effect.targetId, EventType_1.EventType.TurnEnded, Schedule_1.Schedule.Combined(durationValue, 1), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])), this.registerEventHandler(effect.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new CancelEffects_1.CancelEffectsEventHandlerArgs([effect.id])));
                break;
            }
        }
        if (handlersToRemove.length > 0) {
            const removal = new CancelEventHandlers_1.CancelEventHandlersEventHandlerArgs(handlersToRemove);
            const filterSelf = EventFilter_1.EventFilter.mk("EffectCancelled", {
                effectId: {
                    eq: effect.id
                }
            });
            this.registerEventHandler(effect.targetId, EventType_1.EventType.EffectCancelled, Schedule_1.Schedule.Once(), removal, filterSelf);
        }
        return effect.id;
    }
    useSequence(type, withSequence) {
        const sequence = (0, SequenceBuilder_1.mkVfxSequenceBuilder)(type);
        const res = withSequence(sequence);
        const args = sequence.mk();
        const effect = new EffectState_1.EffectState(this.nextId++, Duration_1.Duration.Instant, 0, 0, new __1.ApplyVfxEffectArgs(args), true);
        (0, Record_1.setValue)(this.effects, effect.id, effect);
        Registries_1.Effects.getItem(effect.args.__type).apply(sequence, this, effect);
        this.emitEvent(sequence, 0, new EffectApplied_1.EffectAppliedEventArgs(effect.id));
        return res;
    }
    applyBattleLogText(sequence, targetId, text, color = "black") {
        sequence.push(new __1.BattleLogEntryVfxStepArgs([
            __1.BattleLogEntrySegment.actorName(this, targetId),
            new __1.BattleLogEntrySegment(text, color),
        ]));
    }
    applyFloatingText(sequence, targetId, text, color = "white", size = "medium", speed) {
        const args = new __1.FloatingTextVfxStepArgs(text, new __1.ActorVfxLocationSelector(targetId, "random"), color, size, undefined, undefined, speed);
        sequence.push(args);
    }
    cancelEffect(sequence, effectId) {
        const effect = (0, Record_1.getValueOrDefaultTo)(this.effects, effectId, undefined);
        if (!effect) {
            return;
        }
        else if (effect.duration.type === DurationType_1.DurationType.Instant) {
            // Instant effects cannot be removed.
            return;
        }
        else if (effect.removed) {
            // prevent duplicate removals...
            return;
        }
        if (effect.args.__typeName !== "ApplyVfx") {
            const [text, color] = (0, Effects_1.printEffect)("cancel", effect.args, effect.targetId, this);
            let innerSequence = sequence.pushSequence("parallel")
                .push(new __1.EffectCancelVfxStepArgs(effect.id, new __1.ActorVfxLocationSelector(effect.targetId)));
            if (text) {
                this.applyBattleLogText;
                innerSequence.push(new __1.BattleLogEntryVfxStepArgs([
                    __1.BattleLogEntrySegment.actorName(this, effect.targetId),
                    new __1.BattleLogEntrySegment(text, color),
                ]));
                innerSequence.push(new __1.FloatingTextVfxStepArgs(text, new __1.ActorVfxLocationSelector(effect.targetId), color, "small"));
            }
        }
        // TODO: completely remove effect...
        effect.removed = true;
        const actor = this.actors[effect.targetId];
        const actorEffects = (0, Record_1.getValueOrDefaultTo)(actor.effects, effect.args.__type, []);
        (0, IdArray_1.removeElement)(actorEffects, effect.id);
        Registries_1.Effects.getItem(effect.args.__type).remove(sequence, this, effect);
        this.emitEvent(sequence, effect.targetId, new EffectCancelled_1.EffectCancelledEventArgs(effect.id));
    }
    getEffect(effectId) {
        return this.effects[effectId];
    }
    getEffectMetaValue(effectId, effectType, key, defaultValue) {
        const effect = this.getEffect(effectId);
        if (!effect) {
            return defaultValue;
        }
        else if (effect.args.__type !== EffectType_1.EffectType[effectType]) {
            return defaultValue;
        }
        const meta = effect.meta;
        return meta[key] || defaultValue;
    }
    hasEffectOfType(actorId, type) {
        return this.getEffectsOfType(actorId, type).length > 0;
    }
    getEffectsOfType(actorId, type) {
        if (!this.actors[actorId]) {
            return [];
        }
        return (0, Record_1.getValueOrDefaultTo)(this.actors[actorId].effects, type, []);
    }
    getAllEffects(actorId) {
        return this.actors[actorId].effects;
    }
    isEffectHelpful(effectId) {
        return !this.isEffectHarmful(effectId);
    }
    isEffectHarmful(effectId) {
        var _a, _b;
        return ((_b = (_a = this.getEffect(effectId)) === null || _a === void 0 ? void 0 : _a.args) === null || _b === void 0 ? void 0 : _b.harmful) || false;
    }
    isEffectSupernatural(effectId) {
        var _a;
        return ((_a = this.getEffect(effectId)) === null || _a === void 0 ? void 0 : _a.supernatural) || false;
    }
    getHelpfulEffects(actorId, includeSupernatural = false) {
        const effectsByType = this.getAllEffects(actorId);
        const effectIds = Object.values(effectsByType).flatMap(ids => ids || []);
        const helpfulEffects = [];
        for (const effectId of effectIds) {
            if (!includeSupernatural && this.isEffectSupernatural(effectId)) {
                continue;
            }
            else if (!this.isEffectHelpful(effectId)) {
                continue;
            }
            const effect = this.getEffect(effectId);
            if ((effect === null || effect === void 0 ? void 0 : effect.duration.type) === DurationType_1.DurationType.Instant) {
                continue;
            }
            effect && helpfulEffects.push(effect);
        }
        return helpfulEffects;
    }
    getHarmfulEffects(actorId, includeSupernatural = false) {
        const effectsByType = this.getAllEffects(actorId);
        const effectIds = Object.values(effectsByType).flatMap(ids => ids || []);
        const harmfulEffects = [];
        for (const effectId of effectIds) {
            if (!includeSupernatural && this.isEffectSupernatural(effectId)) {
                continue;
            }
            else if (!this.isEffectHarmful(effectId)) {
                continue;
            }
            const effect = this.getEffect(effectId);
            if ((effect === null || effect === void 0 ? void 0 : effect.duration.type) === DurationType_1.DurationType.Instant) {
                continue;
            }
            effect && harmfulEffects.push(effect);
        }
        return harmfulEffects;
    }
    hasActionsRemaining(actorId) {
        const actor = this.getActor(actorId);
        const actions = 1 + this.getAttributeScore(actorId, AttributeType_1.AttributeType.ExtraActions);
        return actor && actor.actionsTaken < actions;
    }
    canUseAction(actorId) {
        return ![
            this.isDeceased(actorId),
            this.hasEffectOfType(actorId, EffectType_1.EffectType.Stun)
        ].some(Boolean);
    }
    ////////////
    // Events //
    ////////////
    emitEvent(sequence, subject, args) {
        const e = new EventState_1.EventState(this.nextId++, this.eventSequence++, subject, args);
        this.events.push(e);
        sequence = sequence
            .push(new __1.EventApplyVfxStepArgs(e.id))
            .pushSequence("parallel");
        const handlers = (0, Record_1.getValueOrDefaultTo)(this.actors[subject].eventHandlers, args.__type, []).slice();
        for (const handlerId of handlers) {
            const handler = this.eventHandlers[handlerId];
            if (!EventFilter_1.EventFilter.Test(handler.filter, args)) {
                continue;
            }
            Schedule_1.Schedule.update(handler.schedule);
            if (!Schedule_1.Schedule.ready(handler.schedule)) {
                continue;
            }
            Schedule_1.Schedule.emit(handler.schedule);
            Registries_1.EventHandlers.getItem(handler.args.__type).activate(sequence.pushSequence("sequential"), this, handler, e);
            if (Schedule_1.Schedule.expired(handler.schedule)) {
                this.cancelEventHandler(handler.id);
            }
        }
        return e.id;
    }
    ////////////////////
    // Event Handlers //
    ////////////////////
    registerEventHandler(subject, eventType, schedule, args, filter = undefined, sequence = (0, SequenceBuilder_1.mkVfxSequenceBuilder)("none")) {
        const handler = new EventHandlerState_1.EventHandlerState(this.nextId++, subject, eventType, schedule, args, filter);
        (0, Record_1.setValue)(this.eventHandlers, handler.id, handler);
        const handlersByType = (0, Record_1.getValueOrDefaultTo)(this.eventHandlersByEventType, eventType, []);
        handlersByType.push(handler.id);
        const actorHandlers = (0, Record_1.getValueOrDefaultTo)(this.actors[subject].eventHandlers, eventType, []);
        actorHandlers.push(handler.id);
        this.emitEvent(sequence, subject, new EventHandlerRegistered_1.EventHandlerRegisteredEventArgs(handler.id));
        return handler.id;
    }
    registerEventHandlerScript(subject, eventType, schedule, type, args, filter = undefined, sequence = (0, SequenceBuilder_1.mkVfxSequenceBuilder)("none")) {
        return this.registerEventHandler(subject, eventType, schedule, new __1.CustomScriptEventHandlerArgs(type, args), filter, sequence);
    }
    registerAdventureEventHandler(eventType, schedule) {
        this.registerEventHandler(this.adventure.id, eventType, schedule, new __1.TriggerAdventureEventHandlerArgs());
    }
    registerAiEventHandler(aiId, eventType, schedule, subject = aiId) {
        this.registerEventHandler(subject, eventType, schedule, new __1.TriggerAiEventHandlerArgs(aiId));
    }
    cancelEventHandler(handlerId) {
        const handler = this.eventHandlers[handlerId];
        if (!handler) {
            return;
        }
        // unsetValue(this.eventHandlers, handler.id);
        const handlers = this.eventHandlersByEventType[handler.eventType];
        (0, IdArray_1.removeElement)(handlers, handler.id);
        const actorHandlers = this.actors[handler.subject].eventHandlers[handler.eventType];
        (0, IdArray_1.removeElement)(actorHandlers, handler.id);
        this.emitEvent((0, SequenceBuilder_1.mkVfxSequenceBuilder)("none"), handler.subject, new EventHandlerCancelled_1.EventHandlerCancelledEventArgs(handlerId));
    }
    ///////////////
    // Abilities //
    ///////////////
    useAbility(sequence, invokerId, args, requireSlotted) {
        var _a;
        (0, Demand_1.demand)(this.adventure.state === "Active", "GAME_OVER");
        sequence = sequence.pushSequence("sequential");
        const actor = this.getActor(invokerId);
        actor.actionsTaken += 1;
        sequence.push(new __1.BattleLogEntryVfxStepArgs([
            __1.BattleLogEntrySegment.actorName(this, invokerId),
            new __1.BattleLogEntrySegment(` uses ${((_a = __1.AbilityMetas[args.__typeName]) === null || _a === void 0 ? void 0 : _a.name) || args.__typeName}`)
        ]));
        if (requireSlotted === true) {
            // TODO: Validate...
            const [slot, ability] = this.getEquippedAbility(invokerId, args.__typeName);
            (0, Demand_1.demand)(slot !== undefined && ability !== undefined, "ABILITY_NOT_SLOTTED");
            (0, Demand_1.demand)(ability.maxUses < 0 || ability.invokeCounter < ability.maxUses, "ABILITY_EXHAUSTED");
            (0, Demand_1.demand)(!ability.disabled, "ABILITY_DISABLED");
            ability.invokeCounter++;
            if (ability.coolDownTurns > 0) {
                this.applyEffect(sequence, invokerId, invokerId, new DisableAbility_1.DisableAbilityEffectArgs(slot), Duration_1.Duration.Turns(ability.coolDownTurns), true);
            }
        }
        if (args.target.type === TargetType_1.TargetType.OneEnemies && this.hasEffectOfType(invokerId, EffectType_1.EffectType.Taunted)) {
            const [tauntId] = this.getEffectsOfType(invokerId, EffectType_1.EffectType.Taunted);
            const taunt = this.getEffect(tauntId);
            ;
            args.target = Target_1.Target.OneEnemy(taunt.creatorId);
        }
        const ability = new AbilityState_1.AbilityState(this.nextId++, invokerId, args);
        Registries_1.Abilities.getItem(args.__type).activate(sequence, this, ability);
        this.emitEvent(sequence, invokerId, new AbilityUsed_1.AbilityUsedEventArgs(args));
    }
    disableAbility(sequence, actorId, slot) {
        const actor = this.getActor(actorId);
        const ability = actor.abilities[slot];
        if (!ability) {
            return;
        }
        ability.disabled = true;
        this.emitEvent(sequence, actorId, new AbilityDisabled_1.AbilityDisabledEventArgs(slot));
    }
    enableAbility(sequence, actorId, slot) {
        const actor = this.getActor(actorId);
        const ability = actor.abilities[slot];
        if (!ability || !ability.disabled) {
            return;
        }
        ability.disabled = false;
        this.emitEvent(sequence, actorId, new AbilityEnabled_1.AbilityEnabledEventArgs(slot));
    }
    resetAbilityCooldown(sequence, actor, slot) {
        const ability = actor.abilities[slot];
        if (ability === null || ability === void 0 ? void 0 : ability.disabled) {
            this.cancelEventHandler(ability.cooldownEventHandlerId);
            sequence = sequence.pushSequence("parallel");
            this.applyEffect(sequence, actor.id, actor.id, new EnableAbility_1.EnableAbilityEffectArgs(slot), Duration_1.Duration.Instant);
            this.getEffectsOfType(actor.id, EffectType_1.EffectType.DisableAbility)
                .map(id => this.getEffect(id))
                .filter(effect => effect.args.slot === slot)
                .forEach(effect => this.cancelEffect(sequence, effect.id));
        }
    }
    resetAllAbilityCooldowns(sequence, actorId) {
        sequence = sequence.pushSequence("parallel");
        const actor = this.getActor(actorId);
        for (const abilitySlot of this.getEquippedAbilitySlots(actorId)) {
            this.resetAbilityCooldown(sequence, actor, abilitySlot);
        }
    }
    /////////////
    // Actions //
    /////////////
    dispatch(sequence, subject, args) {
        const action = new ActionState_1.ActionState(this.nextId++, this.actionSequence++, subject, args);
        Logger_1.EngineLogger.info(`100|dispatch|adventureId#${this.adventure.adventureId}|subject#${subject}|actionId#${action.id}|eventType#${args.__typeName}`);
        Registries_1.Actions.getItem(args.__type).activate(sequence, this, action);
        return action.id;
    }
    ///////////
    // Rooms //
    ///////////
    addRoom(sequence, args) {
        const room = new RoomState_1.RoomState(this.nextId++, args.type, args.onEntered, args.onExited, args.onTick);
        this.rooms[room.id] = room;
        this.emitEvent(sequence, this.adventure.id, new __1.RoomAddedEventArgs(room.id));
        return room.id;
    }
    getRoom(roomId) {
        const room = (0, Record_1.getValueOrThrow)(this.rooms, roomId, "ROOM_DOES_NOT_EXIST");
        return room;
    }
    hasCurrentRoom() {
        return this.currentRoom > 0;
    }
    setCurrentRoom(roomId) {
        this.currentRoom = roomId;
    }
    //////////
    // Turn //
    //////////
    tickRoomAndAdventure(sequence) {
        if (this.currentRoom === 0) {
            return;
        }
        const room = (0, Record_1.getValueOrThrow)(this.rooms, this.currentRoom, "ROOM_NOT_FOUND");
        if (room.state !== "Active") {
            return;
        }
        let tickSequence = sequence.pushSequence("parallel");
        for (const tick of room.onTick) {
            Registries_1.RoomScripts.getItem(tick.key).run(tickSequence, this, room, tick.args);
        }
        Registries_1.AdventureHandlers.getItem(this.adventure.__typeName).tick(sequence.pushSequence("sequential"), this, this.adventure);
    }
    tick(sequence) {
        // Tick applies at the end of the turn
        for (const actor of this.getActors()) {
            if (actor.faction === Faction_1.Faction.Game) {
                continue;
            }
            this.emitEvent(sequence, actor.id, new __1.TickEventArgs());
        }
        this.tickRoomAndAdventure(sequence);
    }
    startTurn(sequence) {
        (0, Demand_1.demand)(this.nextActor !== 0, "NO_ACTOR");
        (0, Demand_1.demand)(this.adventure.state === "Active", "GAME_OVER");
        sequence = sequence.pushSequence("parallel");
        const nextActor = this.getActor(this.nextActor);
        nextActor.actionsTaken = 0;
        nextActor.turnCount++;
        this.lastTurnStartedAt = Date.now();
        sequence.push(new __1.BattleLogDividerVfxStepArgs("Turn"));
        this.applyBattleLogText(sequence, this.nextActor, "starts turn");
        // Take turn
        this.emitEvent(sequence, this.nextActor, new __1.TurnStartedEventArgs());
        const canUseAction = this.canUseAction(this.nextActor);
        if (!canUseAction) {
            this.endTurn(sequence);
        }
        return canUseAction;
    }
    endAction(sequence, actorId) {
        const startedInRoom = this.currentRoom;
        this.tickRoomAndAdventure(sequence);
        if (startedInRoom !== this.currentRoom) {
            this.emitEvent(sequence, actorId, new __1.TurnEndedEventArgs());
        }
    }
    endTurn(sequence) {
        (0, Demand_1.demand)(this.adventure.state === "Active", "GAME_OVER");
        sequence = sequence.pushSequence("parallel");
        const endingTurnOf = this.nextActor;
        const startedInRoom = this.currentRoom;
        this.tick(sequence);
        if (startedInRoom !== this.currentRoom) {
            return;
        }
        this.applyEffect(sequence, endingTurnOf, endingTurnOf, new __1.TurnMeterDecreaseEffectArgs(this.getTurnMeter(endingTurnOf), false), Duration_1.Duration.Instant);
        sequence.push(new __1.UpdateTurnMeterVfxStepArgs(endingTurnOf, 0));
        this.emitEvent(sequence, endingTurnOf, new __1.TurnEndedEventArgs());
        this.applyBattleLogText(sequence, endingTurnOf, "ends turn");
        // if the room was cleared, the next actor has been set already.
        if (startedInRoom !== this.currentRoom) {
            return;
        }
        const affected = Array.of();
        for (const actor of this.getActors()) {
            if (actor.faction === Faction_1.Faction.Game) {
                continue;
            }
            else if (this.isDeceased(actor.id)) {
                // dead characters have 0 turn meter!
                continue;
            }
            affected.push(actor);
            if (actor.id === this.nextActor) {
                continue;
            }
            this.applyEffect(sequence, this.adventure.id, actor.id, new __1.TurnMeterIncreaseEffectArgs(25, true), Duration_1.Duration.Instant);
        }
        const sorted = affected.sort((a, b) => this.getTurnMeter(a.id) - this.getTurnMeter(b.id));
        sorted.forEach((next, i) => sequence.push(new __1.UpdateTurnMeterVfxStepArgs(next.id, (i + 1) / sorted.length)));
        const nextActor = sorted.at(-1);
        this.nextActor = nextActor === null || nextActor === void 0 ? void 0 : nextActor.id;
    }
    ////////////////
    // Adventures //
    ////////////////
    setAdventure(adventureType, args, adventureId, ownerId) {
        this.adventure = new AdventureState_1.AdventureState(0, adventureType, args, adventureId, ownerId);
    }
    failAdventure(sequence) {
        (0, Demand_1.demand)(this.adventure.state === "Active", "ADVENTURE_NOT_ACTIVE");
        this.adventure.state = "Failed";
        this.emitEvent(sequence, this.adventure.id, new __1.AdventureFailedEventArgs(this.adventure.adventureId));
    }
    completeAdventure(sequence) {
        (0, Demand_1.demand)(this.adventure.state === "Active", "ADVENTURE_NOT_ACTIVE");
        this.adventure.state = "Completed";
        this.emitEvent(sequence, this.adventure.id, new __1.AdventureCompletedEventArgs(this.adventure.adventureId));
    }
}
exports.State = State;
